<template>
    <section class="booking-steps py-30">
        <span class="primary-right-round"></span>
        <div class="container">
            <ul class="d-xl-flex justify-content-center align-items-center">
                <li v-bind:class="{ active: currentPath.includes('/coaches/coach-details') }">
                    <h5><router-link to="/coaches/coach-details"><span>1</span>Type of Booking</router-link></h5>
                </li>
                <li v-bind:class="{ active: currentPath.includes('/coaches/coach-timedate') }">
                    <h5><router-link to="/coaches/coach-timedate"><span>2</span>Time & Date</router-link></h5>
                </li>
                <li v-bind:class="{ active: currentPath.includes('/coaches/coach-personalinfo') }">
                    <h5><router-link to="/coaches/coach-personalinfo"><span>3</span>Personal Information</router-link></h5>
                </li>
                <li v-bind:class="{ active: currentPath.includes('/coaches/coach-order-confirm') }">
                    <h5><router-link to="/coaches/coach-order-confirm"><span>4</span>Order Confirmation</router-link></h5>
                </li>
                <li v-bind:class="{ active: currentPath.includes('/coaches/coach-payment') }">
                    <h5><router-link to="/coaches/coach-payment"><span>5</span>Payment</router-link></h5>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
  data() {
    return {
      currentPath: this.$route.path,
    };
  },
};
</script>